import { CaretDownFilled, SearchOutlined } from '@ant-design/icons'
import { unwrapResult } from '@reduxjs/toolkit'
import {
  Button,
  Col,
  Form,
  Input,
  Row,
  Space,
  Cascader as Cascaded,
} from 'antd'
import React, { ReactElement, useContext, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../app/store'
import { EditableList } from '../../compnents/list/EditableList'
import { NavBar } from '../../compnents/nav/NavBar'
import { TenantQueryParams } from '../../services/tenant'
import { ThemeContext } from '../../theme/ThemeContext'
import { columns } from './ReplaceMakeOrganizationColumns'
import styles from './ReplaceMakeOrganization.module.css'
import { useHistory, useLocation } from 'react-router-dom'
import {
  getReplaceMakeOrganizationList,
  isChangeOrganizationStatus,
} from './ReplaceMakeOrganizationSclice'
import { getAllList } from '../tenant/tenantSlice'
import { changeOrganizationStatus } from '../../services/ReplaceMakeOrganization'

// 代煎机构
export const ReplaceMakeOrganization = (): ReactElement => {
  const theme = useContext(ThemeContext)

  const dispatch = useDispatch<RootDispatch>()

  const [form] = Form.useForm()

  const history = useHistory()

  const location: any = useLocation()

  const queryParams = sessionStorage.getItem('ORGANIZATIONPARAMS') ? JSON.parse(sessionStorage.getItem('ORGANIZATIONPARAMS')!) : null

  const [data, setData] = useState<any>()

  const [total, setTotal] = useState<any>()

  const [params, setParams] = useState<TenantQueryParams>({
    size: 10,
    current: queryParams?.current || 1,
  })

  const [allList, setAllList] = useState<any[]>()

  const loadData = (selectedOptions: any) => {
    const targetOption = selectedOptions[selectedOptions.length - 1]
    targetOption.loading = true
  }

  useEffect(() => {
    form.setFieldsValue({ ...queryParams?.queryParams })
    dispatch(
      getReplaceMakeOrganizationList({
        ...params,
        ...queryParams?.queryParams,
        area: undefined,
        provinceCode:
          queryParams?.queryParams.area?.slice(0, 1)[0] ||
          params?.area?.slice(0, 1)[0],
        cityCode:
          queryParams?.queryParams.area?.slice(1, 2)[0] ||
          params?.area?.slice(1, 2)[0],
        countyCode:
          queryParams?.queryParams.area?.slice(2, 3)[0] ||
          params?.area?.slice(2, 3)[0],
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        setData(res.records)
        setTotal(res.total)
        sessionStorage.removeItem('ORGANIZATIONPARAMS')
      })
  }, [params])

  useEffect(() => {
    console.log(queryParams)

    dispatch(getAllList())
      .then(unwrapResult)
      .then((t: any) => {
        setAllList(t)
        console.log('data', t)
      })
  }, [])

  return (
    <Col
      style={{
        height: 'calc(100% - 20px) ',
        overflow: 'hidden',
        margin: '10px 30px',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <NavBar where={['代煎中心', '代煎机构']} />
      <Col
        style={{
          flex: 1,
          overflow: 'hidden',
          backgroundColor: theme.pn,
          marginTop: 10,
          borderRadius: 10,
          padding: '10px 15px',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Form
          form={form}
          autoComplete='off'
          initialValues={{}}
          onFinish={(values) => {
            setParams({
              ...params,
              ...values,
              current: 1,
            })
          }}
        >
          <Row
            justify='space-between'
            align='middle'
            style={{ marginTop: 10, marginBottom: 20, width: '100%' }}
          >
            <Space>
              <Form.Item name='name' noStyle>
                <Input
                  allowClear
                  placeholder='请输入机构名称/助记码'
                  prefix={<SearchOutlined />}
                  style={{ width: '315px' }}
                  onChange={form.submit}
                />
              </Form.Item>
              <Form.Item name='area' noStyle>
                <Cascaded
                  loadData={loadData}
                  changeOnSelect
                  suffixIcon={<CaretDownFilled style={{ color: theme.tc3 }} />}
                  style={{ width: '240px' }}
                  options={allList}
                  onChange={form.submit}
                  placeholder='请选择省市区'
                />
              </Form.Item>
            </Space>
            <Button type='primary' onClick={form.submit}>
              查询
            </Button>
          </Row>
        </Form>
        <EditableList
          page={{
            items: data,
            current: params.current || 1,
            size: params.size || 10,
            total,
          }}
          style={{ color: theme.tc3 }}
          className={styles.table}
          columns={columns(
            (action, t) => {
              switch (action) {
                case 'toggle':
                  dispatch(
                    isChangeOrganizationStatus({
                      tenantId: t.tenantId,
                      openType: t.openType === 0 ? 1 : 0,
                    })
                  )
                    .then(unwrapResult)
                    .then(() => {
                      dispatch(
                        getReplaceMakeOrganizationList({
                          ...params,
                          area: undefined,
                          provinceCode: params?.area?.slice(0, 1)[0],
                          cityCode: params?.area?.slice(1, 2)[0],
                          countyCode: params?.area?.slice(2, 3)[0],
                        })
                      )
                        .then(unwrapResult)
                        .then((res: any) => {
                          setData(res.records)
                          setTotal(res.total)
                        })
                    })
                  break
                case 'partner':
                  sessionStorage.setItem(
                    'ORGANIZATIONPARAMS',
                    JSON.stringify({
                      current: params.current,
                      queryParams: form.getFieldsValue(),
                    })
                  )
                  history.replace({
                    pathname: '/admin/replaceMakeCenter/OrganizationPartner',
                    state: {
                      tenantId: t.tenantId,
                      tenantName: t.tenantName,
                      platformId: t.platformId,
                      platformName: t.platformName,
                    },
                  })
                  break
              }
            },
            (params.size || 10) * ((params.current || 1) - 1),
            theme
          )}
          onChangePage={(current: number, size?: number) => {
            setParams({
              ...params,
              current: current,
              size: size || 10,
            })
          }}
          onRow={(t) => ({
            onDoubleClick: () => {
              history.replace({
                pathname: '/admin/replaceMakeCenter/OrganizationPartner',
                state: {
                  tenantId: t.tenantId,
                  current: params.current,
                  tenantName: t.tenantName,
                  platformId: t.platformId,
                  platformName: t.platformName,
                },
              })
            },
          })}
        />
      </Col>
    </Col>
  )
}
